export const compareById = (prev: any, next: any) => prev?.id === next?.id;
